import { AdvertisingEvent, PlayerEvent, type PlayerInterface } from '@foundation-player/loader';
import { readonly, writable, type Readable, type Writable } from 'svelte/store';
import type { PlayerStoreModule } from './player-store-types';

export class PlayingPlayerStore implements PlayerStoreModule<'playing' | 'awaitingPlaying'> {
  readonly #playing: Writable<boolean> = writable(false);
  readonly playing: Readable<boolean> = readonly(this.#playing);

  readonly #awaitingPlaying: Writable<boolean> = writable(false);
  readonly awaitingPlaying: Readable<boolean> = readonly(this.#awaitingPlaying);

  initializeStateFromPlayer(player: PlayerInterface) {
    player.addEventListener(PlayerEvent.Ready, () => this.#playing.set(player.isPlaying()));
    player.addEventListener(AdvertisingEvent.AdStarted, () => this.#setPlaying());
    player.addEventListener(PlayerEvent.Play, () => this.#awaitingPlaying.set(true));
    player.addEventListener(PlayerEvent.Error, () => this.#awaitingPlaying.set(false));
    player.addEventListener(PlayerEvent.Playing, () => this.#setPlaying());
    player.addEventListener(PlayerEvent.Paused, () => this.#setNotPlaying());
    player.addEventListener(PlayerEvent.SessionEnd, () => this.#setNotPlaying());

    this.#playing.set(player.isPlaying());
  }

  #setPlaying() {
    this.#playing.set(true);
    this.#awaitingPlaying.set(false);
  }

  #setNotPlaying() {
    this.#playing.set(false);
    this.#awaitingPlaying.set(false);
  }
}
